import React from 'react';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-white pt-2 pb-12 md:pt-14 md:pb-20 px-5" data-id="element-223">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-224">
        {/* Bloque above-the-fold: encaja en una pantalla de iPhone sin scroll */}
        <div className="w-full flex flex-col items-center justify-center min-h-[calc(100svh-48px)] md:min-h-0 md:justify-start py-2 md:py-0" data-id="element-225">
          {/* Eyebrow */}
          <p className="text-[11px] md:text-sm font-bold tracking-[0.2em] uppercase text-brand-amber mb-2 md:mb-7" data-id="element-226">
            Médico en Proceso™ · Medicina Argentina
          </p>

          {/* Headline */}
          <h1 className="text-2xl md:text-6xl font-extrabold text-slate-900 leading-[1.1] md:leading-[1.05] tracking-tight mb-3 md:mb-10" data-id="element-227">
            Toda la carrera de Medicina en un solo lugar.
          </h1>

          {/* Product Image — protagonista, centrada, sin marco pesado */}
          <div className="w-full max-w-xl mb-3 md:mb-10" data-id="element-228">
            <img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Médico en Proceso — Sistema completo de estudio" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl max-h-[26vh] md:max-h-none" data-id="element-229" />
          </div>

          {/* Subtítulo gris */}
          <p className="text-sm md:text-2xl text-slate-500 font-medium leading-snug md:leading-relaxed mb-4 md:mb-9 max-w-xl" data-id="element-230">
            Médico en Proceso™ — Sistema Completo para Estudiantes de Medicina
            Argentina
          </p>

          {/* Píldoras de confianza */}
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-4 md:mb-10 w-full" data-id="element-231">
            {[{
            icon: '📄',
            label: '100% PDF'
          }, {
            icon: '⚡',
            label: 'Acceso Inmediato'
          }, {
            icon: '📚',
            label: '6 Tomos + 6 Bonos'
          }].map((badge, idx) => <div key={idx} className="flex items-center gap-1.5 md:gap-2 bg-white border border-slate-200 shadow-sm px-3 py-1.5 md:px-5 md:py-2.5 rounded-full text-xs md:text-base font-semibold text-slate-700" data-id="element-232">
                <span data-id="element-233">{badge.icon}</span>
                <span data-id="element-234">{badge.label}</span>
              </div>)}
          </div>

          {/* CTA principal */}
          <button onClick={scrollToPricing} className="w-full max-w-xl bg-brand-amber hover:bg-amber-600 text-white text-base md:text-xl font-bold py-4 md:py-5 px-8 rounded-2xl shadow-lg transition-transform hover:scale-[1.02] active:scale-95 flex items-center justify-center gap-2 min-h-[56px]" data-id="element-235">
            🎓 QUIERO ORDENAR MI CARRERA AHORA
          </button>

          {/* Fila de seguridad con divisores */}
          <div className="flex flex-wrap justify-center items-center gap-x-4 md:gap-x-5 gap-y-1.5 mt-4 md:mt-5 text-xs md:text-sm text-slate-500 font-medium" data-id="element-236">
            <span className="flex items-center gap-1.5" data-id="element-237">
              <Shield size={14} data-id="element-238" /> Garantía 7 días
            </span>
            <span className="text-slate-300 hidden sm:inline" data-id="element-239">|</span>
            <span className="flex items-center gap-1.5" data-id="element-240">
              <Lock size={14} data-id="element-241" /> Pago seguro
            </span>
            <span className="text-slate-300 hidden sm:inline" data-id="element-242">|</span>
            <span className="flex items-center gap-1.5" data-id="element-243">
              <CreditCard size={14} data-id="element-244" /> Tarjetas y transferencia
            </span>
          </div>
        </div>

        {/* Cita destacada */}
        <div className="bg-blue-50 border-l-4 border-brand-blue p-6 rounded-r-xl mt-12 md:mt-16 max-w-2xl w-full text-left italic text-brand-blue font-medium text-lg shadow-sm" data-id="element-245">
          "No te falta capacidad. Te falta un sistema claro para estudiar
          Medicina sin perderte."
        </div>

        {/* Texto descriptivo */}
        <p className="text-base md:text-lg text-slate-600 mt-8 max-w-3xl" data-id="element-246">
          El sistema que los mejores estudiantes de Medicina usan para estudiar
          mejor, organizarse y avanzar en la carrera sin depender de apuntes
          incompletos. Armado sobre los planes de estudio oficiales de UBA,
          UNLP, UNC y las principales universidades de Argentina.
        </p>

        {/* Estadísticas / prueba social */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12 w-full max-w-4xl border-t border-slate-200 pt-8" data-id="element-247">
          <div className="text-center" data-id="element-248">
            <div className="font-bold text-xl text-slate-900" data-id="element-249">+1.800</div>
            <div className="text-sm text-slate-600" data-id="element-250">estudiantes confían</div>
          </div>
          <div className="text-center" data-id="element-251">
            <div className="font-bold text-xl text-slate-900" data-id="element-252">3 niveles</div>
            <div className="text-sm text-slate-600" data-id="element-253">disponibles</div>
          </div>
          <div className="text-center" data-id="element-254">
            <div className="font-bold text-xl text-slate-900" data-id="element-255">4.9/5 ⭐</div>
            <div className="text-sm text-slate-600" data-id="element-256">calificación</div>
          </div>
          <div className="text-center" data-id="element-257">
            <div className="font-bold text-xl text-slate-900" data-id="element-258">
              🇦🇷 Todo el país
            </div>
            <div className="text-sm text-slate-600" data-id="element-259">cobertura</div>
          </div>
        </div>
      </div>
    </section>;
}